"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var IconStatusCheck = function IconStatusCheck(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size,
      rest = _objectWithoutProperties(_ref, ["className", "color", "size"]);

  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, rest), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.13 36.95L12.59 24.41L15.41 21.59L24.87 31.05L39.47 13.71L42.53 16.29L25.13 36.95Z",
    fill: color
  }));
};

IconStatusCheck.defaultProps = {
  color: 'black',
  size: 30
};
IconStatusCheck.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconStatusCheck;
exports.default = _default;